import * as React from 'react'
import clazz from 'classnames'
import { Icon } from 'common/ui'
import Spin from '../Spin'
import styled from 'styled-components'

const StyleLayout = styled.button`
  padding: 0 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  .spin {
    margin-right: 3px;
  }

  &:disabled,
  &.loading {
    opacity: 0.5;
  }

  &.loading {
    pointer-events: none;
    > span {
      margin-left: 2px;
    }
  }

  > svg {
    margin-right: 4px;
    font-size: 24px;
  }

  &.large {
    height: 48px;
    font-size: 15px;
    padding: 0 28px;
    min-width: 50px;
  }

  &.tiny {
    height: 40px;
    font-size: 15px;
    padding: 0 30px;
  }

  &.small {
    height: 32px;
    font-size: 12px;
    padding: 0 10px;
  }

  &.long {
    width: 100%;
  }

  &.primary {
    color:#090808;
    background: #E0C286;
    border: none;
    &:not(:disabled):hover {
      background: #ebb851;
    }
  }
  &.outline {
    color: #E0C286;
    background: transparent;
    border: 1px solid #E0C286;
    &:not(:disabled):hover {
      color: #ebb851;
      border-color: #E0C286;
    }
  }

  &.loading,
  &[disabled] {
    cursor: default;
  }
`

export interface ButtonProps {
  disabled?: boolean
  icon?: string
  classnames?: string
  className?: string
  onClick?: React.MouseEventHandler<HTMLElement>
  type?: 'primary' | 'danger' | 'outline' | 'dangerLine'
  size?: 'small' | 'large' | 'tiny'
  long?: boolean
  loading?: boolean
  rawType?: 'submit' | 'button' | 'reset'
  style?: React.CSSProperties
  children?: JSX.Element | string
  iconProps?: { [key: string]: string }
}

const Button = (props: ButtonProps) => {
  const {
    disabled,
    classnames,
    className,
    type = 'default',
    size = 'tiny',
    long,
    loading,
    icon,
    style,
    onClick,
    iconProps,
    rawType = 'button',
  } = props

  const clasname = [
    {
      [type]: !!type,
      long,
      [size]: !!size,
      loading: loading != null && loading,
    },
    classnames,
    className,
  ]

  const handleClick = React.useCallback((e: any) => {
    if (loading) {
      return
    }
    onClick && onClick(e)
  }, [loading, onClick])

  return (
    <StyleLayout
      type={rawType}
      style={style}
      className={clazz([clasname])}
      disabled={disabled}
      onClick={handleClick}>
      {loading && <Spin className="spin" />}
      {icon && <Icon type={icon} {...iconProps} />}
      <span>{props.children}</span>
    </StyleLayout>
  )
}

export default Button